<template>
  <div class="container" :style="containerStyleObj" :class="{ bg: $route.params.id }">
    <Row class="title-wrap" :style="titleWrapStyleObj" ref="titleWrap" v-if="!$route.params.id">
      <Col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 24 }">
      <div class="title" :style="titleStyleObj">
        <img src="../../assets/images/databoard/head-left-icon.png" />
        <span v-on:click="handleFullScreen()">{{
          schoolData.school_name
        }}</span>
        <img src="../../assets/images/databoard/head-right-icon.png" />
      </div>
      <div class="logo" :style="logoStyleObj">
        <!--<img src="../../assets/images/databoard/datedu-logo.png" style="height: 27px;"/>
                    <span class="split-line"></span>-->
        <!--<img src="../../assets/images/databoard/class30-logo.png" />-->
        <template v-if="channel == 'telit'">
          <img :src="`${logoPath}?${timestamp}`" />
          <span class="split-line"></span>
          <img :src="`${yjtLogoPath}?${timestamp}`" />
          <span class="split-line"></span>
          <img src="../../assets/images/databoard/ai-logo.png" style="margin: 3.5px 0" />
        </template>
        <template v-else-if="channel == 'sy' || channel == 'qx'">
          <img src="../../assets/images/databoard/ai-logo.png" style="margin: 3.5px 0" />
        </template>
        <template v-else-if="channel == 'zkxc'">
          <img :src="`${logoPath}?${timestamp}`" />
          <span class="split-line"></span>
          <img src="../../assets/images/databoard/ai_logo-zkxc.png" style="margin: 3.5px 0" />
        </template>
        <template v-else-if="channel == 'nanjing'">
          <img src="../../assets/images/databoard/ai-logo.png" style="margin: 3.5px 0" />
        </template>
        <template v-else>
          <img :src="`${logoPath}?${timestamp}`" />
          <span class="split-line"></span>
          <img src="../../assets/images/databoard/ai-logo.png" style="margin: 3.5px 0" />
        </template>
      </div>
      <!-- 学段筛选：仅多学段用户显示 -->
      <div class="phase-filter" v-if="showPhaseFilter">
        <Select v-model="selectedPhase" placeholder="学段" @on-change="onPhaseChange" style="width:90px">
          <Option v-for="item in phaseOptions" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </div>
      <div class="full-screen" v-on:click="handleFullScreen()">
        <template v-if="!fullscreen">
          <span class="full-icon"><img src="../../assets/images/databoard/full-screen-icon.png" /></span>
          <span class="full-title">全屏</span>
        </template>
        <template v-else>
          <span class="full-icon"><img src="../../assets/images/databoard/exit-full-screen-icon.png" /></span>
          <span class="full-title">取消全屏</span>
        </template>
      </div>
      <div class="statis-report" v-on:click="gotoSchoolList()" v-if="
        freeLoginOrigin != 'xcjyy' &&
        $route.query.origin != 'chart' &&
        channel != 'sy' &&
        channel != 'nanjing'
      ">
        <span class="full-title">统计报表</span>
      </div>
      <div class="future-classroom" v-on:click="gotoFutureClassroomDashBoard()" v-if="
        freeLoginOrigin != 'xcjyy' &&
        $route.query.origin != 'chart' &&
        channel != 'sy' &&
        isShowFutureClassroom
      ">
        <span class="full-title">未来教室展板</span>
      </div>
      <div class="future-classroom" :class="getHomeworkBtnClass()" v-on:click="gotoScanHomeworkDashBoard()"
        v-if="isShowScanHomeworkDashboard">
        <span class="full-title">数智作业展板</span>
      </div>
      <div class="future-classroom" :class="getStudentPadBtnClass()" v-on:click="gotoStudentPadDashBoard()"
        v-if="isShowStudentPadDashboard">
        <span class="full-title">学生机数据看板</span>
      </div>
      </Col>
    </Row>
    <Row :gutter="20" class="statistic-wrap" :style="statisticWrapStyleObj">
      <Col :xs="{ span: 6 }" :sm="{ span: 6 }" :md="{ span: 6 }" :lg="{ span: 6 }" style="padding-right: 0px">
      <!--校本书库统计-->
      <ebook-statis :ebookCountList="ebookCountList" :titleHeight="titleHeight" :screenHeight="screenHeight">
      </ebook-statis>
      <!--课件统计-->
      <courseware-statis :teaCourseware="teaCourseware" :teaCoursewareCount="teaCoursewareCount"
        :titleHeight="titleHeight" :screenHeight="screenHeight"></courseware-statis>

      <!-- 答题互动分析 -->
      <answer-inter-analysis :list="answerInterBehavior" :titleHeight="titleHeight" :screenHeight="screenHeight"
        :schoolName="schoolData.school_name" :schoolId="schoolId"
        v-if="zbSchoolIdList.indexOf(schoolId) > -1"></answer-inter-analysis>

      <!--教师课堂行为分析-->
      <pie-item :paramTeaData="teaBehaviorData" :paramStuData="stuBehaviorData" :titleHeight="titleHeight"
        :screenHeight="screenHeight" v-else-if="zbSchoolIdList.indexOf(schoolId) <= -1"
        :schoolName="schoolData.school_name" :schoolId="schoolId" :form="'school'"></pie-item>
      </Col>
      <!-- <template v-if="Object.keys(schoolData).length > 0"> -->
      <!-- 区级展板 -->
      <template v-if="schoolId == '0'">
        <Col :xs="{ span: 12 }" :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 12 }">
        <div class="statis-count" :style="statisCountStyleObj">
          <Col :xs="{ span: 12 }" :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <div class="count-wrap" style="margin-right: 10px">
            <ul>
              <li v-on:click="lookSchoolStatisInfo('schoolClassList')">
                <infor-card class="data-sur-count-card" style="cursor: pointer" :numStyleObj="numStyleObj"
                  :nameStyleObj="nameStyleObj" :end-val="newSchoolData.class_num" intro-text="班级个数"
                  cardType="dataSupervise" :isConvert="isConvert"></infor-card>
                <span class="right-border"></span>
              </li>
              <li v-on:click="lookSchoolStatisInfo('schoolTeacherList')">
                <infor-card class="data-sur-count-card" style="cursor: pointer" :numStyleObj="numStyleObj"
                  :nameStyleObj="nameStyleObj" :end-val="newSchoolData.tea_num" intro-text="教师人数"
                  cardType="dataSupervise" :isConvert="isConvert"></infor-card>
                <span class="right-border"></span>
              </li>
              <li v-on:click="lookSchoolStatisInfo('schoolStudentList')">
                <infor-card class="data-sur-count-card" style="cursor: pointer" :numStyleObj="numStyleObj"
                  :nameStyleObj="nameStyleObj" :end-val="newSchoolData.stu_sum" intro-text="学生人数"
                  cardType="dataSupervise" :isConvert="isConvert"></infor-card>
              </li>
            </ul>
          </div>
          </Col>
          <Col :xs="{ span: 12 }" :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <div class="count-wrap">
            <ul>
              <li v-on:click="lookStatisInfo('homework')">
                <infor-card class="data-sur-count-card" style="cursor: pointer" :numStyleObj="numStyleObj"
                  :nameStyleObj="nameStyleObj" :end-val="newSchoolData.hw_and_exam_num" intro-text="作业总数"
                  cardType="dataSupervise" :isConvert="isConvert"></infor-card>
                <span class="right-border"></span>
              </li>
              <li v-on:click="lookStatisInfo('resource')">
                <infor-card class="data-sur-count-card" style="cursor: pointer" :numStyleObj="numStyleObj"
                  :nameStyleObj="nameStyleObj" :end-val="newSchoolData.rs_upload_num" intro-text="资源总数"
                  cardType="dataSupervise" :isConvert="isConvert"></infor-card>
                <span class="right-border"></span>
              </li>
              <li v-on:click="lookStatisInfo('microClass')">
                <infor-card class="data-sur-count-card" style="cursor: pointer" :numStyleObj="numStyleObj"
                  :nameStyleObj="nameStyleObj" :end-val="newSchoolData.cw_upload_num" intro-text="微课总数"
                  cardType="dataSupervise" :isConvert="isConvert"></infor-card>
              </li>
            </ul>
          </div>
          </Col>
        </div>
        <div class="tea-oper-dym tea-oper-dym-bg" :style="teaOperDymStyleObj">
          <!-- <span class="border-left-top"></span>
          <span class="border-left-bottom"></span>
          <span class="border-right-top"></span>
          <span class="border-right-bottom"></span> -->
          <!-- <div class="statis-title bg1">
            <span>教学动态</span>
          </div> -->
          <div class="dym-content" :style="teaOperDymStyleObj">
            <tea-dynamic :dynamicData="dynamicData" @openPreview="openPreview" @lookInterInfo="lookInterInfo"
              ref="dynamicRef"></tea-dynamic>
          </div>
        </div>
        <app-trend-analysis :screenHeight="screenHeight" :titleHeight="titleHeight"
          :SchoolMonthActive="SchoolMonthActive" :SchoolWeekActive="SchoolWeekActive" :SchoolDayActive="SchoolDayActive"
          @gotoSchoolList="gotoSchoolList()"></app-trend-analysis>
        <!-- <pie-item name="teaBehavior" :titleHeight="titleHeight" :paramTeaData="teaBehaviorData"
          :paramStuData="stuBehaviorData" :screenHeight="screenHeight"></pie-item> -->
        </Col>
        <Col :xs="{ span: 6 }" :sm="{ span: 6 }" :md="{ span: 6 }" :lg="{ span: 6 }" style="padding-left: 0px">
        <classroom-eva ref="classroomEva" :evlPer="evlPer" :titleHeight="titleHeight" :screenHeight="screenHeight">
        </classroom-eva>
        <classroom-inter :titleHeight="titleHeight" :interTotalNum="baseData.kthdCount" :screenHeight="screenHeight"
          :paramData="classInteractData"></classroom-inter>
        <homework-statis :stuHomework="stuHomework" :titleHeight="titleHeight" :screenHeight="screenHeight">
        </homework-statis>
        </Col>
      </template>
      <!-- 校级展板 -->
      <template v-else>
        <Col :xs="{ span: 12 }" :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 12 }">
        <div class="statis-count" :style="statisCountStyleObj">
          <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="" />
          <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="" />
          <Col :xs="{ span: 12 }" :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <div class="count-wrap">
            <ul>
              <li v-on:click="lookSchoolStatisInfo('schoolClassList')">
                <infor-card class="data-sur-count-card" style="cursor: pointer" :numStyleObj="numStyleObj"
                  :nameStyleObj="nameStyleObj" :startDataVal="newSchoolData.use_class_num"
                  :end-val="newSchoolData.class_num" intro-text="使用班级数/总数" cardType="newDataSupervise"
                  :isConvert="isConvert"></infor-card>
                <span class="right-border"></span>
              </li>
              <li v-on:click="lookSchoolStatisInfo('schoolTeacherList')">
                <infor-card class="data-sur-count-card" style="cursor: pointer" :numStyleObj="numStyleObj"
                  :nameStyleObj="nameStyleObj" :startDataVal="newSchoolData.use_tea_num"
                  :end-val="newSchoolData.tea_num" intro-text="使用教师数/总数" cardType="newDataSupervise"
                  :isConvert="isConvert"></infor-card>
                <span class="right-border"></span>
              </li>
              <li v-on:click="lookSchoolStatisInfo('schoolStudentList')">
                <infor-card class="data-sur-count-card" style="cursor: pointer" :numStyleObj="numStyleObj"
                  :nameStyleObj="nameStyleObj" :startDataVal="newSchoolData.use_stu_num"
                  :end-val="newSchoolData.stu_num" intro-text="使用学生数/总数" cardType="newDataSupervise"
                  :isConvert="isConvert"></infor-card>
                <span class="right-border"></span>
              </li>
            </ul>
          </div>
          </Col>
          <Col :xs="{ span: 12 }" :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <div class="count-wrap">
            <ul>
              <li v-on:click="lookStatisInfo('homework')">
                <infor-card class="data-sur-count-card" :numStyleObj="numStyleObj" :nameStyleObj="nameStyleObj"
                  :startDataVal="-1" :end-val="newSchoolData.hw_and_exam_num" intro-text="作业总数"
                  cardType="newDataSupervise" :isConvert="isConvert"></infor-card>
                <span class="right-border"></span>
              </li>
              <li v-on:click="lookStatisInfo('microClassKj')">
                <infor-card class="data-sur-count-card" :numStyleObj="numStyleObj" :nameStyleObj="nameStyleObj"
                  :startDataVal="newSchoolData.share_num" :end-val="newSchoolData.upload_num" intro-text="分享/上传资源总数"
                  cardType="newDataSupervise" :isConvert="isConvert"></infor-card>
                <span class="right-border"></span>
              </li>
              <li>
                <infor-card class="data-sur-count-card" style="cursor: default" :numStyleObj="numStyleObj"
                  :nameStyleObj="nameStyleObj" :startDataVal="-1" :end-val="allEvalCount" intro-text="评价总数"
                  cardType="newDataSupervise" :isConvert="isConvert"></infor-card>
              </li>
            </ul>
          </div>
          </Col>
        </div>
        <!--教师操作动态-->
        <div class="tea-oper-dym tea-oper-dym-bg" :style="teaOperDymStyleObj">
          <!-- <span class="border-left-top"></span>
          <span class="border-left-bottom"></span>
          <span class="border-right-top"></span>
          <span class="border-right-bottom"></span> -->
          <!-- <div class="statis-title bg1" v-if="!$route.params.id">
            <span>教学动态</span>
          </div> -->
          <div class="dym-content" :style="teaOperDymStyleObj">
            <tea-dynamic-static :dynamicData="dynamicData" @openPreview="openPreview" @lookInterInfo="lookInterInfo"
              v-if="isShowDyStatic"></tea-dynamic-static>
            <tea-dynamic :dynamicData="dynamicData" @openPreview="openPreview" @lookInterInfo="lookInterInfo"
              ref="dynamicRef" v-else></tea-dynamic>
          </div>
        </div>
        <app-trend-analysis :screenHeight="screenHeight" :titleHeight="titleHeight"
          :SchoolMonthActive="SchoolMonthActive" :SchoolWeekActive="SchoolWeekActive" :SchoolDayActive="SchoolDayActive"
          @gotoSchoolList="gotoSchoolList()"></app-trend-analysis>
        <!-- <pie-item name="teaBehavior" :titleHeight="titleHeight" :paramTeaData="teaBehaviorData"
          :paramStuData="stuBehaviorData" :schoolName="schoolData.school_name" :schoolId="schoolId" :form="'school'"
          :screenHeight="screenHeight"></pie-item> -->
        </Col>
        <Col :xs="{ span: 6 }" :sm="{ span: 6 }" :md="{ span: 6 }" :lg="{ span: 6 }" style="padding-left: 0">
        <!--教师评价榜-->
        <teacher-evaluation-board ref="activeDetailStatis" :evlPer="evlPer" :titleHeight="titleHeight"
          :screenHeight="screenHeight" :schoolId="schoolId" :schoolName="schoolData.school_name" :phase="getEffectivePhase()">
        </teacher-evaluation-board>
        <!--教师活跃情况-->
        <active-teacher-statis ref="activeDetailStatis" :evlPer="evlPer" :titleHeight="titleHeight"
          :screenHeight="screenHeight" :schoolId="schoolId" :schoolName="schoolData.school_name" :phase="getEffectivePhase()">
        </active-teacher-statis>
        <!--班级活跃情况-->
        <active-class-statis ref="activeDetailStatis" :evlPer="evlPer" :titleHeight="titleHeight"
          :screenHeight="screenHeight" :schoolId="schoolId" :schoolName="schoolData.school_name" :phase="getEffectivePhase()"></active-class-statis>
        </Col>
      </template>
      <!-- </template> -->
    </Row>
    <!--课堂互动弹框-->
    <div v-show="isShowModal">
      <div class="mask-box"></div>
      <div class="panel-box">
        <div class="close-btn">
          <img class="logo-img" src="../../assets/images/databoard/close_btn.png" width="100%" height="100%"
            v-on:click="closeWin" />
        </div>
        <div class="panel-main">
          <div class="icon-box-wrap">
            <img class="icon-box" :src="currentInter.evaluate_type_icon" width="100%" height="100%"
              v-if="currentInter.evaluate_type_icon != ''" />
            <p class="icon-txt">{{ currentInter.evaluate_type_name }}</p>
          </div>
          <div class="info-box">
            <p>
              <span class="txt-item">{{ currentInter.school_name }}</span>
              <span class="txt-item">{{ currentInter.teacher_real_name }}老师</span>
              对
              <span class="txt-item">{{ currentInter.student_real_name }}</span>
              学生
            </p>
            <p>进行了 “ {{ currentInter.evalContent }} ” 的评价</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 气泡弹窗 -->
    <dt-preview-slider ref="previewSlider" :previewMode="previewMode" :previewVideoMode="previewVideoMode"
      :videoSrc="videoSrc" @closePreview="closePreview"></dt-preview-slider>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import inforCard from "../../components/inforCard.vue"; //数据卡片
import { findUserInfo } from "../../service/api.js";
import {
  findBoardTopData,
  findSchoolData,
  fetchBehaviorData,
  getQueTypeStatAPI,
  getSchoolMonthActive,
  getSchoolWeekActive,
  getSchoolDayActive,
  getTeaResStat,
  getPublicConfigBySchoolInfoApi,
} from "../../service/bigDataApi.js";

//校本书库统计
import ebookStatis from "./modules/ebookStatis";
//课堂评价分析
import classroomEva from "./modules/classroomEva";
//课堂行为分析
import classroomInter from "./modules/classroomInter";
//课件统计
import coursewareStatis from "./modules/coursewareStatis";
//作业统计
import homeworkStatis from "./modules/homeworkStatis";
//实时动态
import teaDynamic from "./modules/teaDynamic.vue";
//实时动态教师上传资源微课数据统计
import teaDynamicStatic from "./modules/teaDynamicStatic.vue";
//教师课堂行为分析
import teaClassroomBehavior from "./modules/teaClassroomBehavior";
//答题互动分析
import answerInterAnalysis from "./modules/answerInterAnalysis";
//教师行为，学生行为
import pieItem from "./modules/pieItem";
// import activeDetailStatis from "./modules/activeDetailStatis";
import teacherEvaluationBoard from "./modules/teacherEvaluationBoard";
import activeClassStatis from "./modules/activeClassStatis";
import activeTeacherStatis from "./modules/activeTeacherStatis";
import appTrendAnalysis from "./modules/appTrendAnalysis";
import { findSchoolInfoById } from "../../service/api";
import user from "../../store/modules/user.js";
// const previewSlider = () => import("./table/baseData/previewSlider");

export default {
  name: "school-index",
  components: {
    inforCard, //数据卡片
    ebookStatis,
    classroomEva,
    classroomInter,
    coursewareStatis,
    homeworkStatis,
    teaClassroomBehavior,
    teaDynamic,
    pieItem,
    activeClassStatis,
    activeTeacherStatis,
    answerInterAnalysis,
    appTrendAnalysis,
    teacherEvaluationBoard,
    teaDynamicStatic,
  },
  computed: {
    ...mapGetters(["freeLoginOrigin", "token"]),
    // 是否显示学段下拉：仅当用户拥有多个学段时显示
    showPhaseFilter() {
      let p = this.$store.getters.phase;
      return p && p.indexOf(',') !== -1;
    },
    // 学段下拉选项
    phaseOptions() {
      let allOpts = [
        { value: '1', label: '小学' },
        { value: '2', label: '初中' },
        { value: '3', label: '高中' }
      ];
      let userPhase = this.$store.getters.phase;
      if (!userPhase) {
        return [{ value: '0', label: '全部学段' }].concat(allOpts);
      }
      let arr = userPhase.split(',');
      let opts = [{ value: '0', label: '全部学段' }];
      allOpts.forEach(item => {
        if (arr.includes(item.value)) opts.push(item);
      });
      return opts;
    },
  },
  data() {
    return {
      isConvert: 1, //是否转换数字
      fullscreen: false,
      schoolData: {},
      newSchoolData: {},
      selectedPhase: '0', //学段筛选选中的值（'0'=全部）
      evlPer: 80,
      teaCourseware: [], //教师课件
      stuHomework: [], //学生作业
      teaClassBehavior: [], //教师课堂行为
      dynamicData: [], //实时动态
      baseData: [], //基础数据
      classInteractData: [], //课堂互动
      classInteractTotal: 0, //课堂互动总数
      teaBehaviorData: [], //教师行为
      stuBehaviorData: [], //学生行为
      ebookCountList: [], //校本书库
      answerInterBehavior: [], //答题互动分析列表
      allEvalCount: 0, //评价总数
      top: [],
      left: [130, 140, 150, 160, 170, 180, 190, 200, 210, 230],
      color: ["#FFF", "#00d8ff", "#ffce23"],
      scrollInterval: {}, //动态滚动区间,
      scrollIngDynamicList: [],
      screenHeight: document.body.clientHeight, // 屏幕默认宽度
      containerStyleObj: {
        height: "",
      },
      titleWrapStyleObj: {
        height: "",
      },
      titleStyleObj: {
        height: "",
      },
      logoStyleObj: {
        height: "",
      },
      statisticWrapStyleObj: {
        height: "",
        margin: "0px 0px 10px 0px",
      },
      statisCountStyleObj: {
        height: "",
      },
      numStyleObj: {
        height: "",
        lineHeight: "",
      },
      nameStyleObj: {
        height: "",
        lineHeight: "",
      },
      teaOperDymStyleObj: {
        height: "",
      },
      dymContentStyleObj: {
        height: "",
      },
      teaCoursewareCount: "", //教师课件总数
      titleHeight: 0,
      countWeight: 700,
      previewMode: false,
      previewVideoMode: false,
      videoSrc: "",
      isShowModal: false,
      currentInter: {},
      tabsName: "", //标签页名称
      schoolId: this.$route.params.schoolId || this.$route.params.id, //学校id
      logoPath: process.env.VUE_APP_DASH_LOGO_PATH,
      yjtLogoPath: process.env.VUE_APP_DASH_YJT_LOGO_PATH,
      timestamp: new Date().getTime(),
      channel: process.env.VUE_APP_CHANNEL,
      // 纸笔放开学校id集合
      zbSchoolIdList: [""],
      SchoolMonthActive: [],
      SchoolWeekActive: [],
      SchoolDayActive: [],
      isShowDyStatic: false,
      // 是否显示未来教室
      isShowFutureClassroom: false,
      // 是否现在扫描作业展板
      isShowScanHomeworkDashboard: false,
      refreshTimer: null, // 添加定时器变量
      userId: this.$route.query.userid,
      adminType: '',
      userType: '',
      //是否显示学生机数据看板
      isShowStudentPadDashboard:false
    };
  },
  created() { },
  watch: {},
  methods: {
    /**
     * 学段切换：重新加载看板数据
     */
    onPhaseChange() {
      this.findTeaBehaviorData();
      this.getBoardTopData();
    },
    /**
     * 获取当前生效的学段（下拉选中值优先，'0'=全部转空）
     */
    getEffectivePhase() {
      let dp = this.selectedPhase;
      if (dp && dp != '0') return dp;
      return '';
    },
    /**
     * 获取数智作业展板按钮的class
     */
    getHomeworkBtnClass() {
      const isBaseCondition = this.freeLoginOrigin != 'xcjyy' &&
        this.$route.query.origin != 'chart' &&
        this.channel != 'sy';

      if (!isBaseCondition) {
        return '';
      }

      // 如果未来教室展板显示，则数智作业展板在第二个位置
      if (this.isShowFutureClassroom) {
        return 'scanhw-btn';
      }

      // 如果未来教室展板不显示，则数智作业展板在第一个位置，不需要额外class（使用默认left: vw(200)）
      return '';
    },
    /**
     * 获取学生机数据看板按钮的class
     */
    getStudentPadBtnClass() {
      const isBaseCondition = this.freeLoginOrigin != 'xcjyy' &&
        this.$route.query.origin != 'chart' &&
        this.channel != 'sy';

      if (!isBaseCondition) {
        return '';
      }

      // 根据前面显示的按钮数量来确定位置
      const buttonsBeforeCount = (this.isShowFutureClassroom ? 1 : 0) +
                                  (this.isShowScanHomeworkDashboard ? 1 : 0);

      if (buttonsBeforeCount === 2) {
        // 未来教室和数智作业都显示时，学生机在第三个位置
        return 'student-btn';
      } else if (buttonsBeforeCount === 1) {
        // 只有一个按钮显示时，学生机在第二个位置
        return 'scanhw-btn';
      }

      // 如果前面没有按钮，学生机在第一个位置，不需要额外class
      return '';
    },
    /**
     * 获取数据展板所有统计数据
     */
    async findTeaBehaviorData() {
      let _this = this;
      // 学校ID，不传是平台的
      let params = {
        schoolId: _this.schoolId == "0" ? "" : _this.schoolId,
        phase: _this.getEffectivePhase(),
      };
      await findSchoolData(params)
        .then(async function (data) {
          // data 可能为空字符串(后端返回"")，需兜底为空对象
          _this.schoolData = (data && typeof data === 'object') ? data : {};
          //获取校本书库
          _this.ebookCountList = _this.schoolData.ebook_count_group ? JSON.parse(_this.schoolData.ebook_count_group) : [];
          // if (_this.schoolId == "976ddfa2f86411e8b8cc00e04c273683") {
          //   _this.ebookCountList[0].ebookTeachingCount = 224
          //   _this.ebookCountList[2].ebookTeachingCount = 10
          //   _this.ebookCountList[5].ebookTeachingCount = 5
          // }
          //获取课件统计
          _this.teaCourseware = _this.schoolData.tea_courseware ? JSON.parse(_this.schoolData.tea_courseware) : [];
          //获取课件总数
          _this.teaCoursewareCount = _this.schoolData.courseware_count || 0;
          // if (_this.schoolId == "976ddfa2f86411e8b8cc00e04c273683") {
          //   _this.teaCoursewareCount = 6982
          //   _this.teaCourseware[0].count = 3406
          //   _this.teaCourseware[1].count = 2721
          //   _this.teaCourseware[2].count = 1296
          //   _this.teaCourseware[3].count = 573
          //   _this.teaCourseware[4].count = 435
          // }
          // if (_this.schoolData.stu_homework != "[]") {
          _this.stuHomework = [
            {
              submitCount: 10683062,
              bank_name: "英语",
              allCount: 13165095,
            },
            {
              submitCount: 10388504,
              bank_name: "数学",
              allCount: 12438786,
            },
            {
              submitCount: 9392622,
              bank_name: "语文",
              allCount: 11218680,
            },
            {
              submitCount: 4402700,
              bank_name: "物理",
              allCount: 5518509,
            },
            {
              submitCount: 3577508,
              bank_name: "生物",
              allCount: 4315120,
            },
          ];
          // }
          // let stu_evaluate = JSON.parse(_this.schoolData.stu_evaluate);
          // if (stu_evaluate.upCount == 0 || stu_evaluate.allCount == 0) {
          //     _this.evlPer = 0;
          // } else {
          _this.evlPer = 91;
          // }
          //   //获取教师课堂行为分析
          //   _this.teaClassBehavior = JSON.parse(
          //     _this.schoolData.tea_class_behavior
          //   );
          _this.dynamicData = JSON.parse(data.dynamic);
          if (_this.isShowDyStatic) {
            await _this.findTeaResStat();
          }
          // _this.baseData = JSON.parse(data.base_data);
          //获取教师行为分析
          _this.teaBehaviorData = JSON.parse(data.tea_behavior);

          //获取学生行为分析
          _this.stuBehaviorData = JSON.parse(data.stu_behavior);

          _this.classInteractData = [
            {
              count: 33046,
              displayCoding: "022",
              displayName: "锁屏管理",
            },
            {
              count: 156077,
              displayCoding: "023",
              displayName: "随机抢答",
            },
          ];
        })
        .catch(function (error) {
          _this.$Message.error(error.message);
        });
    },
    /**
     * 获取学校教师资源统计列表
     */
    async findTeaResStat() {
      let _this = this;
      let params = {
        schoolId: _this.schoolId == "0" ? "" : _this.schoolId,
        keyWord: "",
        sortType: 1,
        order: "desc",
        page: 1,
        limit: 500,
      };
      await getTeaResStat(params)
        .then(function (data) {
          _this.dynamicData = data.rows;
        })
        .catch(function (error) {
          _this.$Message.error(error.message);
        });
    },
    /**
     * 获取课堂行为分析
     */
    async getBehaviorData() {
      let _this = this;
      let params = {
        schoolId: _this.schoolId == "0" ? "" : _this.schoolId,
      };
      await fetchBehaviorData(params)
        .then(function (data) {
          _this.teaClassBehavior = data;
          // if (_this.schoolId == "976ddfa2f86411e8b8cc00e04c273683") {
          //   _this.teaClassBehavior[2].count = 279180
          //   _this.teaClassBehavior[0].count = 217606
          //   _this.teaClassBehavior[1].count = 173679
          //   _this.teaClassBehavior[3].count = 1387
          // }
        })
        .catch(function (error) {
          _this.$Message.error(error.message);
        });
    },
    /**
     * @name 获取答题互动分析
     */
    async getQueTypeStat() {
      if (this.zbSchoolIdList.indexOf(this.schoolId) > -1) {
        let _this = this;
        let params = {
          schoolId: _this.schoolId == "0" ? "" : _this.schoolId,
        };
        await getQueTypeStatAPI(params)
          .then(function (data) {
            _this.answerInterBehavior = data;
          })
          .catch(function (error) {
            _this.$Message.error(error.message);
          });
      }
    },
    /**
     * 获取数据展板所有统计数据
     */
    async getBoardTopData() {
      let _this = this;
      let params = {
        schoolid: _this.schoolId == "0" ? "" : _this.schoolId,
        phase: _this.getEffectivePhase(),
      };
      await findBoardTopData(params)
        .then(function (data) {
          // data 可能为空字符串(后端返回"")，需兜底为空对象
          _this.newSchoolData = (data && typeof data === 'object') ? data : {};
          _this.newSchoolData.upload_num =
            _this.newSchoolData.cw_upload_num +
            _this.newSchoolData.rs_upload_num;
          _this.newSchoolData.share_num =
            _this.newSchoolData.cw_share_num + _this.newSchoolData.rs_share_num;
          _this.newSchoolData.hw_and_exam_num = _this.newSchoolData.hw_num + _this.newSchoolData.exam_num;
          // 评价总数从 summary 接口获取（eval_total_cnt）
          _this.allEvalCount = data.eval_total_cnt || 0;
          // if (data.school_id == "976ddfa2f86411e8b8cc00e04c273683") {
          //   _this.newSchoolData.cw_share_num = 176
          //   _this.newSchoolData.rs_share_num = 273
          //   _this.newSchoolData.use_tea_num = 64
          //   _this.newSchoolData.use_class_num = 30
          //   // _this.newSchoolData.hw_num = 3142
          // }
        })
        .catch(function (error) {
          _this.$Message.error(error.message);
        });
    },
    /**
     * 全屏
     */
    handleFullScreen() {
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
    /**
     * 查看学校列表
     */
    gotoSchoolList() {
      let _this = this;
      // let routeData = this.$router.resolve({
      //   name: "schoolList",
      // });
      // window.open(routeData.href, "_blank");
      let token = this.token;
      let routeData =
        "/mobile/schoolBoard/" +
        this.schoolId +
        "/" +
        this.schoolData.school_name +
        "?userid=" +
        this.$store.getters.userId +
        "&token=" +
        token;
      window.open(routeData, "_blank");
    },
    /**
     * 查看资源，作业，课堂评价等统计详情
     */
    lookStatisInfo(val) {
      if (this.channel != "sy") {
        if (Object.keys(this.schoolData).length > 0) {
          let _this = this;
          let routeData = this.$router.resolve({
            name: "schoolNewDataList",
            params: {
              schoolId:
                this.schoolData.school_id === null
                  ? "0"
                  : this.schoolData.school_id,
              schoolName: this.schoolData.school_name,
              filtersName: "0",
              classId: "0",
              gradeId: "0",
              subjectId: "0",
              tabsName: val,
              teaId: "0",
            },
          });
          window.open(routeData.href, "_blank");
        } else {
          this.$Message.info("数据正在获取中，请稍后再试！");
        }
      }
    },
    /**
     * 查看班级、教师、学生等统计详情
     */
    lookSchoolStatisInfo(name) {
      if (this.channel != "sy") {
        let _this = this;
        let routeData = this.$router.resolve({
          name: name,
          params: {
            schoolId:
              this.schoolData.school_id === null
                ? "0"
                : this.schoolData.school_id,
            schoolName: this.schoolData.school_name,
          },
        });
        window.open(routeData.href, "_blank");
      }
    },

    /**
     * 预览资源
     */
    openPreview(resultUrl, count, type) {
      // type 0:其他 1.文档 2.视频 3.音频 4.图片
      if (type === 2) {
        this.previewVideoMode = true;
        this.videoSrc = resultUrl + "/video.mp4";
        return;
      } else if (type === 3) {
        this.$Message.error("音频文件，暂时无法预览！");
        return;
      }
      if (!count) {
        this.$Message.error("暂无缩略图，无法预览！");
        return;
      }
      this.previewMode = true;
      this.$refs.previewSlider.swiperInit(resultUrl, count);
    },
    // 关闭预览
    closePreview(type) {
      this[type] = false;
      // //继续开始滚动
      // this.$refs.dynamicRef.hoverEvent();
      // this.$refs.dynamicRef.mouseleaveEvent();
    },
    /**
     * 查看互动详情
     */
    lookInterInfo(interObj) {
      this.isShowModal = true;
      this.currentInter = interObj;
      //互动评价
      this.currentInter.evalContent = this.currentInter.evaluate_type_name;
    },
    /**
     * 关闭弹窗
     */
    closeWin() {
      this.isShowModal = false;
      this.currentInter = {};
      // //继续开始滚动
      // this.$refs.dynamicRef.hoverEvent();
      // this.$refs.dynamicRef.mouseleaveEvent();
    },
    //评价总数已改为从 getBoardTopData(summary接口) 获取 eval_total_cnt
    //获取学校产品使用趋势图数据
    async getSchoolProductUseTrendData() {
      let params = {
        schoolId: this.schoolId == "0" ? "" : this.schoolId,
      };
      await getSchoolDayActive(params)
        .then((data) => {
          this.SchoolDayActive = data.filter(
            (item) =>
              item.type === 1 ||
              item.type === 2 ||
              item.type === 3 ||
              item.type === 4
          );
        })
        .catch((error) => {
          this.$Message.error("获取数据失败！");
        });
      await getSchoolWeekActive(params)
        .then((data) => {
          this.SchoolWeekActive = data.filter(
            (item) =>
              item.type === 1 ||
              item.type === 2 ||
              item.type === 3 ||
              item.type === 4
          );
        })
        .catch((error) => {
          this.$Message.error("获取数据失败！");
        });
      await getSchoolMonthActive(params)
        .then((data) => {
          this.SchoolMonthActive = data.filter(
            (item) =>
              item.type === 1 ||
              item.type === 2 ||
              item.type === 3 ||
              item.type === 4
          );
        })
        .catch((error) => {
          this.$Message.error("获取数据失败！");
        });
    },

    /**
     * 进入未来教室数据展板
     */
    gotoFutureClassroomDashBoard() {
      let routeData = this.$router.resolve({
        name: "nanjingdataboard",
        query: {
          schoolId: this.schoolId,
        },
      });
      window.open(routeData.href, "_blank");
    },
    /**
     * 进入扫描作业数据展板
     */
    gotoScanHomeworkDashBoard() {
      window.open(`https://gc.iclass30.com/bigdata/bigscreen?schoolId=${this.schoolId}&schoolName=${this.schoolData.school_name}&userId=${this.$store.state.user.userId}&token=${this.$store.state.user.token}`, "_blank");
    },
    /**
     * 进入学生机数据展板
     */
     gotoStudentPadDashBoard() {
      let routeData = this.$router.resolve({
        name: "studentpad",
        query: {
          schoolId: this.schoolId,
          schoolName:this.schoolData.school_name
        },
      });
      window.open(routeData.href, "_blank");
    },
    /**
     * 是否有未来教室进入权限
     * @return {Promise<void>}
     */
    async classroomPower() {
      let params = {
        schoolId: this.schoolId,
        userId: this.$store.state.user.userId,
        dictCode: "120,160,164",
      };
      await getPublicConfigBySchoolInfoApi(params)
        .then((data) => {
          if (data.length > 0) {
            let item = data[0];
            let nowTime = this.$moment(new Date()).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            let expireTime = this.$moment(item.expireTime).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            if (nowTime < expireTime) {
              if (item.state === "1") {
                this.isShowFutureClassroom = true;
              }
            }
            console.log('adminType', this.adminType)
            console.log('useType', this.userType)
            if (data[1].state === "1" && (this.adminType === 2 || this.userType === 5)) {
              this.isShowScanHomeworkDashboard = true;
            }
            if(data[2].state === "1"){
              this.isShowStudentPadDashboard = true;
            }
          }
        })
        .catch((error) => {
          this.$message.warning(error.message);
        });
    },
    /**
     * 初始化页面
     */
    initPage() {
      const _this = this;
      this.$nextTick(() => {
        let windowHeight = window.innerHeight;
        if (windowHeight < 900) {
          windowHeight = 938;
          document.getElementsByTagName("body")[0].className = "active";
        }
        let titleHeight = 128;
        let statisticHeight = windowHeight - titleHeight - 10;
        let statisHeight = windowHeight / 12.5;
        let dymHeight =
          statisticHeight - statisHeight - statisticHeight / 3 - 20;
        this.titleHeight = titleHeight;
        this.containerStyleObj.height = windowHeight + "px";
        this.titleWrapStyleObj.height = titleHeight + "px";
        this.titleStyleObj.height = titleHeight * 0.4 - 10 + "px";
        this.logoStyleObj.height = titleHeight * 0.3 + "px";
        this.statisticWrapStyleObj.height = statisticHeight + "px";
        this.statisCountStyleObj.height = statisHeight + "px";
        this.numStyleObj.height = statisHeight * 0.6 + "px";
        this.numStyleObj.lineHeight = statisHeight * 0.6 + "px";
        this.nameStyleObj.height = statisHeight * 0.4 + "px";
        this.nameStyleObj.lineHeight = statisHeight * 0.4 + "px";
        this.teaOperDymStyleObj.height = dymHeight + "px";
        this.dymContentStyleObj.height = dymHeight - 49 + "px";

        if (
          this.schoolId === "9877620af86411e8b8cc00e04c402959" ||
          this.schoolId === "04f5138f95674ceab170a977e152e527"
        ) {
          this.isShowDyStatic = true;
        }
        //获取数据展板所有统计数据
        this.findTeaBehaviorData();
        this.getBoardTopData();
        this.getBehaviorData();
        this.getQueTypeStat();
        this.getSchoolProductUseTrendData();
      });

      // 注：window.onresize只能在项目内触发1次
      window.onresize = function windowResize() {
        // 通过捕获系统的onresize事件触发我们需要执行的事件
        let windowHeight = document.body.clientHeight;
        if (windowHeight < 900) {
          windowHeight = 938;
          document.getElementsByTagName("body")[0].className = "active";
        }
        _this.screenHeight = windowHeight;
        let titleHeight = 128;
        let statisticHeight = windowHeight - titleHeight - 10;
        let statisHeight = windowHeight / 12.5;
        let dymHeight =
          statisticHeight - statisHeight - statisticHeight / 3 - 20;
        _this.titleHeight = titleHeight;
        _this.titleHeight = titleHeight;
        _this.containerStyleObj.height = windowHeight + "px";
        _this.titleWrapStyleObj.height = titleHeight + "px";
        _this.titleStyleObj.height = titleHeight * 0.4 - 10 + "px";
        _this.logoStyleObj.height = titleHeight * 0.3 + "px";
        _this.statisticWrapStyleObj.height = statisticHeight + "px";
        _this.statisCountStyleObj.height = statisHeight + "px";
        _this.numStyleObj.height = statisHeight * 0.6 + "px";
        _this.numStyleObj.lineHeight = statisHeight * 0.6 + "px";
        _this.nameStyleObj.height = statisHeight * 0.4 + "px";
        _this.nameStyleObj.lineHeight = statisHeight * 0.4 + "px";
        _this.teaOperDymStyleObj.height = dymHeight + "px";
        _this.dymContentStyleObj.height = dymHeight - 49 + "px";
      };

      // 初始化获取未来教室权限
      this.classroomPower();
    },
    /**
     * 刷新页面数据
     */
    refreshData() {
      this.findTeaBehaviorData();
      this.getBoardTopData();
      this.getBehaviorData();
      this.getQueTypeStat();
      this.getSchoolProductUseTrendData();
    },
    /**
     * 启动定时刷新
     */
    startAutoRefresh() {
      // 清除可能存在的旧定时器
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
      }
      // 设置新的定时器,每10分钟刷新一次
      this.refreshTimer = setInterval(() => {
        this.refreshData();
      }, 10 * 60 * 1000);
    },
    /**
     * 根据用户id获取用户信息
     */
    async findUserInfoByuserId() {
      const res = await findUserInfo({ userId: this.userId });
      if (res) {
        this.adminType = res.admin_type;
        this.userType = res.user_type;
      }
    }
  },
  async mounted() {
    const _this = this;
    if (this.schoolId == '0') {
      this.$store
        .dispatch("getUserRole", {
          userId: this.$store.state.user.userId,
        })
        .then((res) => {
          console.log("roleIds", _this.$store.getters.roleIds);
          if (_this.$store.getters.roleIds.includes("33") || _this.$store.getters.roleIds.includes("81")) {
            this.initPage();
            this.startAutoRefresh(); // 添加这行,启动定时刷新
          } else {
            this.$router.push({
              name: "errorpage",
            });
          }
        })
        .catch((res) => {
          this.$Message.error(res.msg);
        });
    } else {
      console.log('userId:', this.userId)
      if (this.userId && this.userId != 'undefind') {
        await this.findUserInfoByuserId();
      }
      this.initPage();
      this.startAutoRefresh(); // 添加这行,启动定时刷新
    }
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../style/databoard";
@import "../../style/detailPage";

.panel-box {
  background-image: url("../../assets/images/databoard/modal-bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

@font-face {
  font-family: MaravaleExpanded;
  src: url("../../assets/fonts/digifaw.ttf"); //字体路径
}

.container {
  background-image: url("../../assets/images/databoard/bg5.png");
  background-size: cover;
  background-repeat: no-repeat;
}

.bg {
  background-image: none;
}

.tea-oper-dym-bg {
  border: unset;
  box-shadow: unset;
  background: unset;
}

.title-wrap {
  background-image: url("../../assets/images/databoard/head-bg.png");
  background-repeat: no-repeat;
  background-position: top;
}

/* 学段筛选下拉：定位到右上角全屏按钮左侧 */
.phase-filter {
  position: absolute;
  top: vh(20);
  right: vw(175);
  height: vw(59);
  display: flex;
  align-items: center;
  z-index: 10;
}

// .count-wrap {
//   height: 100%;
//   background-image: url("../../assets/images/databoard/count-bg.png");
//   background-size: 100% 100%;
//   background-repeat: no-repeat;
// }

.full-screen {
  background-image: url("../../assets/images/databoard/full-screen-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.statis-report {
  background-image: url("../../assets/images/databoard/full-screen-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.future-classroom {
  background-image: url("../../assets/images/databoard/full-screen-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.bg1 {
  background-image: url("../../assets/images/databoard/title-bg1.png");
}

.top-left {
  position: absolute;
  top: 0;
  left: 0;
  width: 14px;
  height: 14px;
}

.right-bottom {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 14px;
  height: 14px;
}
</style>

<style lang="scss">
body {
  background-color: #000 !important;
  overflow-x: hidden;
  overflow-y: hidden;
}

.active {
  overflow-x: auto;
  overflow-y: auto;
}

/* 学段下拉深色主题，适配看板头部背景 */
.phase-filter {
  .ivu-select-selection {
    background-color: rgba(10, 18, 39, 0.6) !important;
    border: 1px solid rgba(112, 138, 204, 0.5) !important;
    box-shadow: none !important;
  }
  .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
  .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    color: #ffffff !important;
  }
  .ivu-select-arrow {
    color: #708acc !important;
  }
  .ivu-select-dropdown {
    background: rgba(10, 18, 39, 0.97) !important;
    box-shadow: inset 0px 0px 10px 4px rgba(14, 252, 255, 0.15) !important;
    border-radius: 5px;
  }
  .ivu-select-item {
    color: #ffffff !important;
    text-align: center;
  }
  .ivu-select-item:hover,
  .ivu-select-item-focus {
    background: #ffffff !important;
    color: #0a1227 !important;
  }
}
</style>
